const key = 'social_banner_available';

export const isOpenBlocked = !!JSON.parse(localStorage.getItem(key));

export const blockOpen = () => localStorage.setItem(key, '1');
